module.exports = __webpack_public_path__ + "img/chr_ts_14_penlight.381b6fb1.png";